import Http from "@/commons/Http";

const path = 'api/user';

export default {

    async save(dto, id = ''){
        return Http.post(`${path}/${id}`, dto);
    },

    async getLoggedUser(){
        return Http.get('/api/autenticacao').catch(() => null);
    },

    async changePassword(dto, id = ''){
        return Http.post(`${path}/password/${id}`, dto);
    },

    async getById(id){
        return Http.get(`${path}/${id}`);
    },

    async getAll(){
        return Http.get(`${path}`);
    },

    async audit(sort, direction, page, size){
        const filters = {entity: "CoffUser"};
        return Http.post(`${path}/audit?sort=${sort || 'a.created'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, {filters});
    },

    async pagination(sort, direction, page, size, filters = {}){
        return Http.post(`${path}/pagination?sort=${sort || 'cu.name'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, filters);
    },

}
